import {axios} from "@/api/config";
// 查询管控措施管理列表
export function listRiskCtrl(params) {
  return axios.get(`/riskCtrl/list`, params, true);
}
export function getRiskCtrlList(params) {
  return axios.get(`/riskCtrl/getRiskCtrlList`, params, true);
}
// 查询管控措施管理详细
export function getRiskCtrl(ctrlId) {
  return axios.get(`/riskCtrl/${ctrlId}`, ctrlId, true)
}

// 新增管控措施管理
export function addRiskCtrl(params) {
  return axios.post('/riskCtrl/addRiskCtrl', params, false);
}

// 修改管控措施管理
export function updateRiskCtrl(params) {
  return axios.post('/riskCtrl/editRiskCtrl', params, false);
}


// 删除管控措施管理
export function delRiskCtrl(ctrlId) {
  return axios.delete(`/riskCtrl/${ctrlId}`, true)
}

